































import { Component, Vue, Prop } from 'vue-property-decorator'
import { MediaComponentProps } from './VideoCallRoomContainer.vue'

@Component({
  components: {
    UserIcon: () => import('./VideoCallUserIcon.vue'),
    SubScreen: () => import('./VideoCallSubScreen.vue')
  }
})
export default class VideoCallSubScreenList extends Vue {
  @Prop(Array) participants!: Array<MediaComponentProps>

  readonly MAX_SUB_SCREEN_NUMBER = 6

  handleSelectUserIcon(id: number) {
    this.$emit('changeMainScreen', id)
  }

  handleSelectSubScreen(id: number) {
    this.$emit('changeMainScreen', id)
  }
}
